import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import classes from './OptionCard.module.scss';

interface OptionCardProps {
    title: string;
    imageSrc?: string;
    subtitle?: string;
    description?: string;
    onDelete?: () => void;
    onClick?: () => void;
}

export const OptionCard: React.FC<OptionCardProps> = ({
    title,
    imageSrc,
    subtitle,
    description,
    onDelete,
    onClick
}) => {
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                {imageSrc && <img src={imageSrc} alt={title} className={classes.image} />}

                <div className={classes.titleContainer}>
                    <span className={classes.title} onClick={onClick}>
                        {title}
                    </span>
                    <div className="flex flex-col gap-1">
                        {subtitle && <span className="text-base font-medium">{subtitle}</span>}
                        {description && <span className={classes.description}>{description}</span>}
                    </div>
                </div>
            </div>

            <div className={classes.actions}>
                {onDelete && (
                    <button type="button" className={classes.deleteButton} onClick={onDelete}>
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                )}

                <Button
                    size="small"
                    variant="outlined"
                    onClick={onClick}
                    className={classes.button}
                >
                    {onDelete ? 'Edit' : 'Add'}
                </Button>
            </div>
        </div>
    );
};
